import React from 'react';
import EmptyAccessState from '@/app/components/EmptyAccessState';
import { Tabs, TabsContent } from '@/shared/ui/tabs';
import PageFrame from '../../../shared/components/patterns/PageFrame';
import PageHeader from '../../../shared/components/patterns/PageHeader';
import {
  PasswordSettingsCard,
  ProfileSettingsForm,
  SettingsTabs,
} from '@/modules/settings/components';
import { useProfileSettings, useSecuritySettings } from '@/modules/settings/hooks';
import { useSession } from '@/app/providers/session-provider';
import WorkspaceSettingsPanel from '@/modules/workspace-settings/components/WorkspaceSettingsPanel';
import { useWorkspaceSettingsData } from '@/modules/workspace-settings/hooks/useWorkspaceSettingsData';
import '@/modules/settings/styles/settings.css';

export default function SettingsPage() {
  const { capabilities } = useSession();
  const profile = useProfileSettings();
  const security = useSecuritySettings();
  const workspaceSettings = useWorkspaceSettingsData();
  const canManageWorkspaceSettings = capabilities?.canManageWorkspaceSettings === true;

  if (!profile.isAuthenticated) {
    return (
      <EmptyAccessState
        title="Sessione non disponibile"
        description="Non c'e una sessione attiva. Effettua di nuovo il login per accedere alle impostazioni del profilo e della sicurezza."
      />
    );
  }

  return (
    <PageFrame className="settings-page">
      <PageHeader
        title="Impostazioni"
        description="Gestisci profilo, sicurezza e configurazione workspace"
      />

      <Tabs defaultValue="profile" className="w-full">
        <SettingsTabs showWorkspaceTab={canManageWorkspaceSettings} />

        <TabsContent value="profile">
          <ProfileSettingsForm
            profile={profile.profile}
            isEditing={profile.isEditing}
            isLoading={profile.isLoading}
            isSaving={profile.isSaving}
            profileMissing={profile.profileMissing}
            statusMessage={profile.statusMessage}
            onFieldChange={profile.updateField}
            onEdit={() => profile.setIsEditing(true)}
            onSave={profile.saveProfile}
            onCancel={profile.cancelEditing}
          />
        </TabsContent>

        <TabsContent value="security">
          <div className="space-y-6">
            <PasswordSettingsCard
              security={security.security}
              status={security.passwordStatus}
              isEditing={security.editMode.password}
              onOpenEdit={() => security.openSection('password')}
              onCancel={() => security.closeSection('password')}
              onConfirm={security.submitPasswordChange}
              onFieldChange={security.updateField}
              onToggleVisibility={security.togglePasswordVisibility}
            />

          </div>
        </TabsContent>

        {canManageWorkspaceSettings ? (
          <TabsContent value="workspace">
            <WorkspaceSettingsPanel
              data={workspaceSettings}
              canManageWorkspaceSettings={canManageWorkspaceSettings}
            />
          </TabsContent>
        ) : null}
      </Tabs>
    </PageFrame>
  );
}
